<template>
  <section>
    <b-sidebar
      type="is-light"
      :fullheight="fullheight"
      :fullwidth="fullwidth"
      :overlay="overlay"
      :right="right"
      v-model="open"
      :can-cancel="canCancel"
      @close="sidebarClosed"
    >
      <slot name="content"></slot>
    </b-sidebar>
  </section>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class Sidear extends Vue {
  @Prop({ required: true, default: false }) open
  @Prop({ required: true, default: false }) canCancel
  data () {
    return {
      overlay: true,
      fullheight: true,
      fullwidth: false,
      right: false
    }
  }

  openSidebar () {
    console.log('openSidebar')
    this.open = true
  }

  sidebarClosed () {
    this.$emit('closed')
  }
}
</script>

<style>
.p-1 {
  padding: 1em;
}
</style>
